import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface ProductFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function ProductField({
  options,
  loading,
  disabled = false,
}: ProductFieldProps) {
  const { t } = useTranslation('create-alarm-step');

  return (
    <>
      <Form.Item
        name="produtos"
        label={t('create-alarm-step:stepOne.createAlarmProductField')}
        rules={[
          {
            required: true,
            message: t('create-alarm-step:stepOne.createAlarmProductRequired'),
          },
        ]}
      >
        <Select
          mode="multiple"
          allowClear
          options={options}
          loading={loading}
          disabled={loading || disabled}
        />
      </Form.Item>
    </>
  );
}
